import { render, staticRenderFns } from "./params.vue?vue&type=template&id=3ed77854&scoped=true&"
import script from "./params.vue?vue&type=script&lang=js&"
export * from "./params.vue?vue&type=script&lang=js&"
import style1 from "./params.vue?vue&type=style&index=1&id=3ed77854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed77854",
  null
  
)

export default component.exports